import {IconCard} from "@/pages/news/sections/SecondSection/components/IconCard";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Card} from "antd";

export const SecondSection = () => {
    const features = [
        {
            name: 'Nguồn ứng viên chất lượng',
            description:
                'Nhà tuyển dụng có thể tiếp cận nguồn ứng viên dồi dào với hơn 10 triệu hồ sơ và hơn 50 triệu lượt truy cập mỗi năm',
            src: "/img/newspage/ic_people.png",
        },
        {
            name: 'Trải nghiệm toàn diện',
            description:
                'Tài khoản nhà tuyển dụng được tích hợp thêm các tính năng thông minh, giúp thuận tiện quản lý tin đăng, quản lý hồ sơ và theo dõi ứng viên,...',
            src: "/img/newspage/ic_diamond.png",
        },
        {
            name: 'Hoàn toàn miễn phí',
            description:
                'Đặc quyền đăng tin tuyển dụng miễn phí giúp nhà tuyển dụng tối ưu chi phí & quy trình tuyển dụng, tiết kiệm thời gian và công sức',
            src: "/img/newspage/ic_money_bag.png",
        },
        {
            name: 'Chất lượng CSKH chuyên nghiệp',
            description:
                'Đội ngũ CSKH giờ tập trung cho vieclamsanxuat chuyên nghiệp hơn & tận tình hơn, nhằm mang lại trải nghiệm tốt nhất và hiệu quả tối đa',
            src: "/img/newspage/ic_support.png",
        },
    ]

    return (
        <div className="px-2 lg:p-12 bg-white">
            <div className="text-center max-w-3xl mx-auto">
                <p className="lg:text-4xl text-2xl font-semibold tracking-tight text-gray-900">
                    Vieclamsanxuat - website việc làm phổ biến nhất Việt Nam
                    với gần 5 năm kinh nghiệm trên thị trường
                </p>
            </div>

            <div className="mt-16 hidden max-w-4xl mx-auto lg:grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-10">
                {features.map((feature) => (
                    <IconCard key={feature.name} {...feature} />
                ))}
            </div>
            {/*Mobile*/}
            <div className={"block lg:hidden mt-4"}>
                <div className={"grid grid-cols-1 gap-4"}>
                    {features.map((feature) => (
                        <Card className={"p-2 shadow-lg bg-gradient-to-bl from-green-100 to-purple-300 rounded-md"}>
                            <div className={"flex gap-2 text-center"}>
                                <div>
                                    <h3 className={"text-lg font-semibold"}>{feature.name}</h3>
                                    <p className={"text-gray-500"}>{feature.description}</p>
                                </div>
                            </div>
                        </Card>
                    ))}
                </div>
            </div>

            <div className="flex justify-center mt-16">
                <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full transition duration-300">
                    Liên hệ tư vấn ngay!
                </button>
            </div>
        </div>
    );
}